import React from 'react';
import { Button, Typography, Space } from '@app/ui';
import { ExclamationCircleOutlined } from '@ant-design/icons';

type CrashedComponentProps = {
    onReload: () => void;
    canReload: boolean;
};

const CrashedComponent: React.FC<CrashedComponentProps> = ({
    onReload,
    canReload,
}) => {
    return (
        <div
            style={{
                width: '100%',
                padding: '48px 0',
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Space direction="vertical" size="middle" align="center">
                <Typography.Title
                    level={2}
                    style={{ color: '#faad14', margin: 0 }}
                >
                    <ExclamationCircleOutlined />
                </Typography.Title>
                <Typography.Text type="danger" strong>
                    Component Loading Error
                </Typography.Text>
                {canReload && (
                    <Button
                        onClick={onReload}
                        size="small"
                        type="primary"
                        color="primary"
                        variant="solid"
                    >
                        Reload
                    </Button>
                )}
            </Space>
        </div>
    );
};

export default CrashedComponent;
